import { Progress } from "semantic-ui-react";
import { banksFormat } from "../../utils/bankList";
import { months } from "../../utils/months"
import { useState } from "react";
import { formatMoneyWithCurrency } from "../../utils/formatter";

const banksTableWidths = {
  bankInfo: 40,
  bankCurrency: 10,
  bankReconciledTransactions: 14,
  bankTotalReceived: 18,
  bankTotalSpend: 18
}

const currenciesSummaryTableWidths = {
  csInfo: 15,
  csReconciledTransactions: 25,
  csTotalReceived: 30,
  csTotalSpend: 30
}

export const HMRRow = ({
  hmr
}) => {

  const [contentVisibility, setContentVisibility] = useState(false)

  const [year, month] = hmr.period.split('-');

  const rowMonth = months[parseInt(month)]

  const unReconciledTransactionsCount = hmr.transactionsCount - hmr.reconciledTransactionsCount;

  const reconciledTransactionsProgress = ((hmr.reconciledTransactionsCount / hmr.transactionsCount) * 100).toFixed(1);

  const onClickHMRRow = () => {
    setContentVisibility(!contentVisibility);
  }

  return (
    <div >
      <div style={{ cursor: 'pointer' }} onClick={onClickHMRRow}>

        <h3 className="text-black bg-transparent" style={{ fontSize: '14pt' }}>
          {`${rowMonth} ${year}`}
        </h3>

        <div className="d-flex flex-column align-items-center">
          <Progress
            className="hmr-progress-bar"
            percent={reconciledTransactionsProgress}
            progress
            success={unReconciledTransactionsCount === 0}
          >
          </Progress>
          {
            unReconciledTransactionsCount === 0
              ?
              <p className="m-0 fw-bold text-success" style={{ fontSize: '9pt' }}>¡Conciliado!</p>
              :
              <p className="m-0 fw-bold " style={{ fontSize: '9pt' }}>
                {`Tienes ${unReconciledTransactionsCount} movimientos por conciliar`}
              </p>
          }

        </div>
      </div>

      {
        contentVisibility &&
        <div>

          <div>
            {
              hmr.banks.map(bank => {

                const key = bank.bankId + bank.accountNumber + bank.currency;

                return (
                  <div key={key} className="d-flex flex-row py-3 border-bottom">

                    {/* BANK INFO COLUMN */}
                    <div
                      className="d-flex align-items-center"
                      style={{ width: `${banksTableWidths.bankInfo}%` }}
                    >
                      <p className="m-0 fw-semibold">
                        {`${banksFormat[bank.bankId]} - Cuenta ${bank.accountNumber}`}
                      </p>
                    </div>

                    {/* BANK CURRENCY COLUMN */}
                    <div
                      className="d-flex flex-column align-items-center"
                      style={{ width: `${banksTableWidths.bankCurrency}%` }}
                    >
                      <small className="m-0">
                        Moneda
                      </small>
                      <small className="m-0">
                        {bank.currency}
                      </small>
                    </div>

                    {/* BANK RECONCILED TRANSACTIONS COLUMN */}
                    <div
                      className="d-flex flex-column align-items-center"
                      style={{ width: `${banksTableWidths.bankReconciledTransactions}%` }}
                    >
                      <small className="m-0">
                        Mov. Conciliados
                      </small>
                      <small className="m-0">
                        {`${bank.reconciledTransactionsCount}/${bank.transactionsCount}`}
                      </small>
                    </div>

                    {/* BANK TOTAL RECEIVED COLUMN */}
                    <div
                      className="d-flex flex-column align-items-center"
                      style={{ width: `${banksTableWidths.bankTotalReceived}%` }}
                    >
                      <small className="m-0">
                        Total de Abonos
                      </small>
                      <small className="m-0">
                        {formatMoneyWithCurrency(bank.receivedTransactionsTotal, bank.currency)}
                      </small>
                    </div>

                    {/* BANK TOTAL SPEND COLUMN */}
                    <div
                      className="d-flex flex-column align-items-center"
                      style={{ width: `${banksTableWidths.bankTotalSpend}%` }}
                    >
                      <small className="m-0">
                        Total de Cargos
                      </small>
                      <small className="m-0">
                        {formatMoneyWithCurrency(bank.spendTransactionsTotal, bank.currency)}
                      </small>
                    </div>
                  </div>
                )
              })
            }
          </div>

          <div>
            {
              hmr.currenciesSummary.map(cs => {
                return (
                  <div key={cs.currency} className="d-flex flex-row py-3">

                    {/* CS INFO COLUMN */}
                    <div
                      className="d-flex"
                      style={{ width: `${currenciesSummaryTableWidths.csInfo}%` }}
                    >
                      <p className="m-0 fw-bold" style={{ fontSize: '9pt' }}>
                        {`Resumen (${cs.currency})`}
                      </p>
                    </div>

                    {/* CS RECONCILED TRANSACTIONS COLUMN */}
                    <div
                      className="d-flex justify-content-center"
                      style={{ width: `${currenciesSummaryTableWidths.csReconciledTransactions}%` }}
                    >
                      <p className="m-0" style={{ fontSize: '9pt' }}>
                        {`Mov. Conciliados: ${cs.reconciledTransactionsCount}/${cs.transactionsCount}`}
                      </p>
                    </div>

                    {/* CS TOTAL RECEIVED COLUMN */}
                    <div
                      className="d-flex justify-content-center"
                      style={{ width: `${currenciesSummaryTableWidths.csTotalReceived}%` }}
                    >
                      <p className="m-0" style={{ fontSize: '9pt' }}>
                        {`Total de Abonos: ${formatMoneyWithCurrency(cs.receivedTransactionsTotal, cs.currency)}`}
                      </p>
                    </div>

                    {/* CS TOTAL SPEND COLUMN */}
                    <div
                      className="d-flex justify-content-center"
                      style={{ width: `${currenciesSummaryTableWidths.csTotalSpend}%` }}
                    >
                      <p className="m-0" style={{ fontSize: '9pt' }}>
                        {`Total de Cargos: ${formatMoneyWithCurrency(cs.spendTransactionsTotal, cs.currency)}`}
                      </p>
                    </div>
                  </div>
                )
              })
            }
          </div>
        </div>
      }
    </div>
  )
}
